import { DeviceRunMode } from '@/api/devices/types';

/**
 * Spotters on map are considered inactive (either not included or color faded) when their last update was more than 24 hours ago.
 */
export const INACTIVE_SPOTTER_MS = 24 * 60 * 60 * 1000;

export const deviceModes: { id: `${number}`; label: string; value: DeviceRunMode }[] = [
    { id: '1', label: 'Waves: Standard', value: 'waves' },
    { id: '2', label: 'Waves: Partition', value: 'partition' },
    { id: '3', label: 'Waves: Spectrum', value: 'full' },
    { id: '4', label: 'Track', value: 'track' },
];

export const operatingModeToUpdateRateOptionsMap: Record<
    DeviceRunMode | '',
    { id: `${DeviceRunMode}-${number}`; label: string; value: `${number}` }[]
> = {
    waves: [
        { id: 'waves-1', label: '1 hour', value: '1' },
        { id: 'waves-0.5', label: '30 minutes', value: '0.5' },
    ],
    partition: [{ id: 'partition-1', label: '1 hour', value: '1' }],
    full: [
        { id: 'full-1', label: '1 hour', value: '1' },
        { id: 'full-2', label: '2 hour', value: '2' },
        { id: 'full-3', label: '3 hour', value: '3' },
        { id: 'full-4', label: '4 hour', value: '4' },
        { id: 'full-5', label: '5 hour', value: '5' },
        { id: 'full-6', label: '6 hour', value: '6' },
    ],
    track: [{ id: 'track-1', label: '15 minutes', value: '0.25' }],
    '': [],
};

export const cellularDeploymentTypeOptions = [
    { id: 'cellular-ocean', label: 'Ocean', value: 'cellular-ocean' },
    { id: 'cellular-lake', label: 'Lake/Bay', value: 'cellular-lake' },
];

export const cellularDeploymentConversionMap = {
    '0.025': { fMin: 0.025, fMax: 0.8, name: 'Ocean', value: 'cellular-ocean' },
    'cellular-ocean': { fMin: 0.025, fMax: 0.8, name: 'Ocean', value: 'cellular-ocean' },

    '0.1': { fMin: 0.1, fMax: 0.8, name: 'Lake/Bay', value: 'cellular-lake' },
    'cellular-lake': { fMin: 0.1, fMax: 0.8, name: 'Lake/Bay', value: 'cellular-lake' },
};

export const cellularProcessingRateOptions = [
    { id: 'cellular-processing-rate-15', label: '15 minutes', value: '15' },
    { id: 'cellular-processing-rate-20', label: '20 minutes', value: '20' },
    { id: 'cellular-processing-rate-30', label: '30 minutes', value: '30' },
    { id: 'cellular-processing-rate-60', label: '60 minutes', value: '60' },
];
export const DEFAULT_SAMPLE_INTERVAL_DURATION_MS = 300_000 as const; // 5 minutes

/**
 * If an SPL reading is within the last <this many> minutes, we'll call it current.
 * TODO https://app.shortcut.com/sofar/story/284300/clean-up-sampling-windows-post-bluetide
 */
export const SPL_READING_WINDOW_MINUTES = 10;
